import React from 'react';
import Title from '../../atoms/Title';
import StepSmall from '../../atoms/StepSmall';
import styled from 'styled-components';
import Grid from 'components/UI/atoms/Grid';

interface IProps {
  title?: string;
  subject?: string;
  step?: number;
  depth?: number;
  direction?: 'row' | 'column';
  subButton?: React.ReactNode; // 새로 추가 (옵션)
}

/** 공통 바깥 래퍼: border-bottom 유지 */
const Wrap = styled.div`
  position: relative;
  width: 100%;
  border-bottom: 2px solid #333;
  padding-bottom: 15px;
`;

/** 기존 레이아웃용: Title + StepSmall 한 줄 */
const DefaultRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

/** Title + subButton 묶음 (타이틀 옆 버튼) */
const TitleAndButton = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;

  /* 제목이 개행되지 않도록 강제 */
  white-space: nowrap;

  /* flex item 줄바꿈 방지 핵심 */
  min-width: 0;
`;

/** subject 스타일 (기존 Title의 subTitle과 최대한 비슷하게) */
const SubTitleTag = styled.h4`
  font-weight: 500;
  padding-top: 10px;
  font-size: 18px;
`;

function TitleWrap({ title, subject, step, depth, direction, subButton }: IProps) {
  // 1) subButton 없으면 → 기존 레이아웃 100% 그대로
  if (!subButton) {
    return (
      <Wrap>
        <DefaultRow>
          <Title subTitle={subject} direction={direction}>
            {title}
          </Title>
          {step && <StepSmall step={step} direction={direction} depth={depth} />}
        </DefaultRow>
      </Wrap>
    );
  }

  // 2) subButton 있으면 → 새 레이아웃 (모범 이미지처럼)
  return (
    <Wrap>
      {/* 1줄: Title + subButton */}
      <DefaultRow>
        <TitleAndButton>
          <Title direction={direction}>{title}</Title>
          {subButton}
        </TitleAndButton>
      </DefaultRow>

      {/* 2줄: subject + StepSmall */}
      <DefaultRow>
        <Grid>
          <SubTitleTag>{subject}</SubTitleTag>
        </Grid>
        {step && <StepSmall step={step} direction={direction} depth={depth} />}
      </DefaultRow>
    </Wrap>
  );
}

export default TitleWrap;
